import styled from "styled-components";

export const Container = styled.div`
  max-width: 900px;
  padding: 20px;
  margin: 0 auto;
`;
